import { styled } from '@mui/material';

export const Root = styled('div')({
    display: 'flex',
});

export const SecondaryContent = styled('main')(({ theme }) => ({
    flex: 1,
    position: 'relative',
    height: 'max-content',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
        width: '100%',
    },
    backgroundColor: '#FFFFFF',
}));

export const ContentWrapper = styled('div')(({ theme }) => ({
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1, 0),
    },
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
}));
